module.exports = __webpack_public_path__ + "ac.no1.3e451ca9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ac.no1.jpg
// module id = Nqfc
// module chunks = 0